import { styled } from '@automata/mui-theme';
import { lighten } from '@mui/material/styles';
import { useMemo } from 'react';

import { colorLightenFactor } from '../../../styles';

const PolygonStyled = styled('polygon')<{ baseColor: string }>`
  fill: ${(p) => lighten(p.baseColor, colorLightenFactor)};
  stroke: ${(p) => p.baseColor};
  transition: stroke-width 0.1s, stroke 0.1s;
  stroke-width: 2px;
  &.hovered {
    stroke: ${(p) => p.theme.palette.neutral[900]};
  }
  &.selected {
    stroke-width: 4px;
    stroke: ${(p) => p.theme.palette.neutral[900]};
  }
`;

type Props = {
  color: string;
  isSelected: boolean;
  isHovered: boolean;
  size?: number;
};

export const Hexagon = ({
  color,
  isSelected,
  isHovered,
  size = 100,
}: Props) => {
  const points: string = useMemo(() => {
    const radius = size / 2.1;
    return [0, 1, 2, 3, 4, 5, 6]
      .map((_, i) => {
        const angle_deg = 60 * i - 30;
        const angle_rad = (Math.PI / 180) * angle_deg;
        return [
          size / 2 + radius * Math.cos(angle_rad),
          size / 2 + radius * Math.sin(angle_rad),
        ];
      })
      .map((p) => p.join(','))
      .join(' ');
  }, [size]);

  return (
    <svg width={size} height={size}>
      <PolygonStyled
        points={points}
        baseColor={color}
        className={[
          isSelected ? 'selected' : '',
          isHovered ? 'hovered' : '',
        ].join(' ')}
      />
    </svg>
  );
};
